<template>
    <Appstore/>
</template>

<script>
import { Appstore } from 'shared'

export default {
    name: 'appstore',
    components: {
        Appstore
    },
    created() {
        this.$store.commit('getAppId', [
            {
                value: 6013,
                label: '健康'
            },
            {
                value: 6020,
                label: '医疗'
            }
        ])
    }
}
</script>